export default "__VITE_ASSET__ded88037__"